import { useState } from 'react';

import { KubesoloTest } from '@api/types.gen';

import { FormSection } from '@@/form-components/FormSection';

import { ConnectionTestDetails } from './ConnectionTestDetails';
import { ProgressHeader } from './ProgressHeader';

interface Props {
  test: KubesoloTest;
}

export function ConnectionTestResults({ test }: Props) {
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);

  return (
    <FormSection title="Connection test">
      <ProgressHeader
        test={test}
        onViewDetails={() => setIsDetailsOpen(true)}
      />
      {isDetailsOpen && (
        <ConnectionTestDetails
          test={test}
          onDismiss={() => setIsDetailsOpen(false)}
        />
      )}
    </FormSection>
  );
}
